import React from 'react'
import { forwardRef, HTMLAttributes, ReactNode, ElementType } from 'react'
import classNames from 'classnames'

interface Props extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode
    className?: string
}

const ModalBody = forwardRef<HTMLDivElement, Props>(({
    children,
    className,
    ...otherProps
}, ref) => {

    const _className = classNames('modal-body', className)

    return (
        <div
            ref={ref}
            className={_className}
            {...otherProps}>
            {children}
        </div>
    )
})

export default ModalBody
ModalBody.displayName = 'ModalBody'
